import React from 'react';
import logo from "../images/logo.jpg";
import { useLocation } from "react-router-dom";
import FaIcon from '../utils/FaIcon';
import { ModularBoxes, CableTrays } from '../utils/constants';

const MenuBar = () => {
  const { pathname = '/' } = useLocation();
  const [showMenu, setShowMenu] = React.useState(false);
  return (
    <div className='menu-bar'>
      <div className="logo">
        <img src={logo} alt="Logo" />
        <h1>Glometal<small style={{ fontSize: '1rem' }}>®</small></h1>
      </div>
      <div className='tripund'>
        <input type="checkbox" id="tripund-checkbox" onChange={() => setShowMenu(!showMenu)}/>
        <label htmlFor="tripund-checkbox">
          <FaIcon icon="bars" />
        </label>
      </div>
      <div className={`overlay ${showMenu ? 'showMenu' : ''}`} onClick={() => setShowMenu(!showMenu)}>click anywhere to close menu</div>
      <nav className={`${showMenu ? 'showMenu' : ''}`}>
        <ul>
          <li><a className={(pathname === '/' || pathname === '/home') && 'active'} href="/">Home</a></li>
          <li><a className={pathname === '/about' && 'active'} href="/about">About</a></li>
          <li><a className={!!CableTrays.find(item => `/cable-trays/${item.id}` === pathname) && 'active'} href="#">Cable Trays</a>
            <FaIcon icon="caret-down" />
            <ul>
              {CableTrays.map((item, index) => (
                <li key={index}>
                  <a href={`/cable-trays/${item.id}`} className={pathname === `/cable-trays/${item.id}` && 'active'}>{item.name}</a>
                </li>
              ))}
            </ul>
          </li>
          <li><a href="/modular-boxes" className={pathname === '/modular-boxes' && 'active'}>Modular Boxes</a></li>
          <li><a href="/contact" className={pathname === '/contact' && 'active'}>Contact</a></li>
        </ul>
      </nav>
    </div>
  );
};

export default MenuBar;
